<template>
  <div id="SAE">
    <div
      style="width: 940px; margin-bottom: 20px; margin-top: 0px; position: relative;"
      class="lk_content_info_block"
    >
      <div style="display: table-cell; width: 70px">
        <el-icon
          style="
            font-size: 50px;
            position: absolute;
            transform: rotate(180deg);
            left: 20px;
            color: #e82862;
          "
          ><Warning
        /></el-icon>
      </div>
      <div style="display: table-cell">
        <br />
        <span >
          Курсы обучения торговли опционами - результат многих лет преподавания ( >10 лет) Сергеем Елисеевым основам торговли опционами более тысячи опционных трейдером. Курс обучения содержит уникальные видео уроки, контрольные тесты по каждой теме и задания.
        </span>
        
        <br /><br />
      </div>
    </div>
    <!--<div class="lk_content_title" style="margin-bottom: 20px">Обучение</div> -->
    <div class="SAESblockHeader">
      <div>Обучение</div>
    </div>
    <div>
      <div class="SAEblock" v-for="(item, i) in levels" :key="i">
        <div
          :style="{
            'background-position-x': item.imgx,
            background: 'url(' + serverUrl + '/' + item.img + ')',
            'background-repeat-y': 'no-repeat',
            'background-position-y': item.imgy + 'px',
          }"
          class="SAEimg"
        ></div>
        <div class="SAEname">
          {{ item.name }} <br /><span class="SAEnamestatic">УРОВЕНЬ</span>
        </div>
        <div class="SAEheader">{{ item.header }}</div>
        <div class="SAEcontent">
          {{ item.content
          }}<span @click="SelectLevel('level', i)" class="viewfull"
            >Читать полностью</span
          >
        </div>
        <div class="SAEprice">
          ЦЕНА:
          <span
            ><b>{{ item.price }}</b></span
          >
          AE токен
        </div>
        <Button
          anglecolor="#00a76b"
          text="Оставить заявку"
          class="SAEbutton"
          @click="ConfirmOrder('level', i)"
        ></Button>
      </div>
    </div>
    <!-- tests -->
    <div class="SAESblockHeader">
      <div>Тесты</div>
    </div>
    <div style="margin-top: 40px">
      <div
        style="
          width: 676px;
          margin-top: -24px;
          margin-bottom: 80px;
          position: relative;
        "
        class=""
      >
        <div style="margin-bottom: 30px">
          Пройдите тесты на знание базовых понятий и параметров опционов
        </div>
        <div style="display: flex">
          <a
            v-for="(item, index) in tests"
            :key="index"
            class="testCard"
            :href="item.url"
            target="_blank"
          >
            <div>
              <div
                v-html="item.image"
                style="width: 48px; height: 48px; margin-bottom: 16px"
              ></div>
              <div class="testCardText">{{ item.name }}</div>
            </div>
            <div style="position: absolute; bottom: 113px">
              {{ item.count }} вопросов
            </div>
            <Button
              style="width: 262px; position: absolute; bottom: 32px"
              text="Подробнее"
            ></Button>
          </a>
        </div>
      </div>
    </div>
    <ServiceHistotyTable>
      <template v-slot:mtthead="">
        <div class="th">Date</div>
        <div class="th">Levels</div>
        <div class="th">Status</div>
      </template>
      <template v-slot:mttbody="props">
        <div class="tr" v-show="props.item.Service == 'levels'">
          <div class="td">{{ props.item.Date }}</div>
          <div class="td">{{ props.item.HistoryInfo.service }}</div>
          <div class="td">{{ props.item.Status }}</div>
        </div>
      </template>
    </ServiceHistotyTable>
  </div>
  <el-dialog v-model="levelInfoDialog" :title="levels[selectedLevel].header">
    <LevelInfo :idl="selectedLevel" :key="selectedLevel"></LevelInfo>
  </el-dialog>
  <el-dialog v-model="strategesInfoDialog" :title="getStrategeTitle()">
    <StrategesInfo
      :ids="selectedStratege"
      :key="selectedStratege"
    ></StrategesInfo>
  </el-dialog>
  <el-dialog
    v-if="indicators.length > 0"
    v-model="indicatorInfoDialog"
    :title="indicators[selectedIndicator].header"
  >
    <IndicatorInfo
      :idi="selectedIndicator"
      :key="selectedIndicator"
    ></IndicatorInfo>
  </el-dialog>

  <el-dialog
    v-model="strategeConfirmDialog"
    :title="getStrategeTitle()"
    width="400px"
  >
    При подписке на стратегию, а также при отписке комиссия не взимается. При
    совершении трейдов применяется повышенная комиссия биржи.
    <br /><br />
    <el-input-number
      v-model="strategePrice"
      :min="strategeMinPrice"
      :max="strategeMaxPrice"
      controls-position="right"
      class="myinputnumber"
    />
    USDT
    <template #footer>
      <span class="dialog-footer">
        <el-button class="SAEcancelB" @click="CancelStratege"
          >Отменить</el-button
        >
        <el-button class="SAEconfirmB" @click="SendStratege"
          >Отправить</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { ElMessageBox, ElMessage, ElInputNumber, ElButton } from "element-plus";
import { useMyStorage, getInstruments } from "../store/global";
import Button from "./Button";
import LevelInfo from "./LevelInfo";
import StrategesInfo from "./StrategesInfo";
import IndicatorInfo from "./IndicatorInfo";
import ServiceHistotyTable from "./ServiceHistotyTable";
import axios from "axios";
import { Warning } from "@element-plus/icons-vue";

export default defineComponent({
  name: "LevelsComponent",
  props: { acName: String },
  components: {
    Button,
    LevelInfo,
    IndicatorInfo,
    StrategesInfo,
    ElInputNumber,
    ElButton,
    ServiceHistotyTable,
    Warning
  },
  setup(props) {
    const store = useMyStorage();
    const levels = reactive(store.learningLevels);
    const indicators = reactive(store.indicators);
    const strateges = reactive(store.strateges);
    const positions = store.getPositionsFull;
    const instruments = getInstruments();
    const levelInfoDialog = ref(false);
    const selectedLevel = ref(0);
    const indicatorInfoDialog = ref(false);
    const selectedIndicator = ref(0);
    const strategesInfoDialog = ref(false);
    const strategeConfirmDialog = ref(false);
    const strategeMinPrice = ref(0);
    const strategeMaxPrice = ref(0);
    const strategePrice = ref(0);
    const strategeSubscribe = ref(false);
    const selectedStratege = ref(0);
    const sendServiceName = ref("");
    const sendServicePrice = ref(0);
    const serverUrl = store.ServerUrl;
    const tests = reactive(store.tests);
    const prp = ref(props);
    const AddInstrument = (ticker) => {
      if (instruments[ticker] == undefined) {
        store.subscribeInstrument(ticker);
      }
    };
    const IsSetPosition = (ticker) => {
      var rez = false;
      for (let acc in positions.value) {
        positions.value[acc].forEach((element) => {
          if (element.Ticker === ticker) {
            return (rez = true);
          }
        });
      }
      return rez;
    };
    const SelectLevel = (type, id) => {
      sendServiceName.value = "";
      sendServicePrice.value = 0;
      console.log(id);
      if (type === "level") {
        selectedLevel.value = id;
        levelInfoDialog.value = true;
      }
      if (type === "indicators") {
        selectedIndicator.value = id;
        indicatorInfoDialog.value = true;
      }
      if (type === "strateges") {
        selectedStratege.value = id;
        strategesInfoDialog.value = true;
      }
    };
    const CancelStratege = () => {
      strategeConfirmDialog.value = false;
      ElMessage({
        type: "error",
        message: "Заявка отменена",
      });
    };
    const SendStratege = () => {
      if (strategePrice.value == 0) {
        return;
      }
      const id = selectedStratege.value % 100;
      const group =
        (selectedStratege.value - (selectedStratege.value % 100)) / 100 - 1;
      let accounts = store.GetAllAccountsToString();
      let sub = "отписка ";
      if (strategeSubscribe.value) {
        sub = "подписка ";
      }
      let body =
        "Заявка на приобретение услуги: " +
        strateges[group].blockItems[id].priceTicker +
        "\r\n ЛК " +
        store.serverConf[store.currentServer].name +
        "\r\n e@mail: " +
        store.userInfo.value.Roles.email +
        "\r\n  счета клиента: " +
        accounts +
        "\r\n услуга: " +
        sub +
        strateges[group].blockItems[id].priceTicker +
        "\r\n объём: " +
        strategePrice.value;
      let data = {
        To: "client@ae.exchange",
        Subject:
          "Заявка на приобретение услуги: " +
          strateges[group].blockItems[id].priceTicker,
        Body: body,
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + store.token.value;
      axios
        .post(store.ServerUrl + "/users/sendtelegramm", data)
        .then(function (resp) {
          console.log(resp);
        })
        .catch(function (err) {
          console.log(err);
        });
      console.log(data);
      strategeConfirmDialog.value = false;
      ElMessage({
        type: "success",
        message: "Заявка отправлена",
      });
    };
    const ConfirmStratege = (ids, subscribe) => {
      strategeSubscribe.value = subscribe;
      selectedStratege.value = ids;
      strategeMinPrice.value = 0;
      strategeMaxPrice.value = 0;
      strategePrice.value = 0;
      const id = selectedStratege.value % 100;
      const group =
        (selectedStratege.value - (selectedStratege.value % 100)) / 100 - 1;
      console.log(strateges[group].blockItems[id].priceTicker);
      if (subscribe) {
        strategeMinPrice.value = 100;
        //     instruments.value[strateges[id].priceTicker].Last;
        strategePrice.value = strategeMinPrice.value;
        strategeMaxPrice.value = 10000000000000000000;
      } else {
        for (let acc in positions.value) {
          positions.value[acc].forEach((element) => {
            if (
              element.Ticker === strateges[group].blockItems[id].priceTicker
            ) {
              strategePrice.value =
                element.Shares * instruments.value[element.Ticker].Last;
              strategeMaxPrice.value = strategePrice.value;
            }
          });
        }
      }
      strategeConfirmDialog.value = true;
    };
    const ConfirmOrder = (type, i) => {
      const msg = ref("");
      if (type === "level") {
        sendServiceName.value = levels[i].header;
        sendServicePrice.value = levels[i].price;
        msg.value =
          "С вашего счёта будет списано <span style='font-size:150%'><b>" +
          levels[i].price +
          "</b></span> AE токен за услугу <b>'" +
          levels[i].header +
          "'</b>. После списания, вам будет отправлено письмо с материалами по данной услуге. ";
      }
      if (type === "indicators") {
        sendServiceName.value = indicators[i].header;
        sendServicePrice.value = indicators[i].price;
        msg.value =
          "С вашего счёта будет списано <span style='font-size:150%'><b>" +
          indicators[i].price +
          "</b></span> AE токен за услугу <b>'" +
          indicators[i].header +
          "'</b>. После списания, вам будет отправлено письмо с материалами по данной услуге. ";
      }

      ElMessageBox.confirm(msg.value, "Внимание", {
        confirmButtonText: "Отправить",
        cancelButtonText: "Отменить",
        dangerouslyUseHTMLString: true,
        cancelButtonClass: "SAEcancelB",
        confirmButtonClass: "SAEconfirmB",
        //  type: 'warning',
      })
        .then(() => {
          let accounts = store.GetAllAccountsToString();

          let body =
            "Заявка на приобретение услуги: " +
            sendServiceName.value +
            "\n\r ЛК " +
            store.serverConf[store.currentServer].name +
            "\n\r e@mail: " +
            store.userInfo.value.Roles.email +
            "\n\r  счета клиента: " +
            accounts +
            "\n\r услуга: " +
            sendServiceName.value +
            "\n\r цена: " +
            sendServicePrice.value;
          let data = {
            To: "client@ae.exchange",
            Subject: "Заявка на приобретение услуги: " + sendServiceName.value,
            Body: body,
          };
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + store.token.value;
          axios
            .post(store.ServerUrl + "/users/sendtelegram", data)
            .then(function (resp) {
              console.log(resp);
            })
            .catch(function (err) {
              console.log(err);
            });
          ElMessage({
            type: "success",
            message: "Заявка отправлена",
          });
          let info =
            "{'service':'" +
            sendServiceName.value +
            "', 'login':'" +
            store.userInfo.value.Name +
            "'}";
          let shis = {
            service: "levels",
            accounts: accounts,
            email: store.userInfo.value.Roles.email,
            status: "pending",
            historyinfo: info,
          };
          axios
            .post(store.ServerUrl + "/users/savesevicehistory", shis)
            .finally(() => {
              store.LoadServiceHistory(accounts);
            });
        })
        .catch(() => {
          ElMessage({
            type: "error",
            message: "Заявка отменена",
          });
        });
    };

    const activeName = ref("first");
    if (prp.value.acName != "") {
      activeName.value = prp.value.acName;
    }
    //    const handleClick = (tab, event) => {
    //   console.log(tab, event);
    //   console.log(activeName.value);
    //  };
    const getStrategeTitle = () => {
      if (selectedStratege.value == 0) {
        return "";
      }
      const id = selectedStratege.value % 100;
      const group =
        (selectedStratege.value - (selectedStratege.value % 100)) / 100 - 1;
      //  console.log(group)
      //  console.log(id)
      return strateges[group].blockItems[id].header;
    };
    return {
      levels,
      ConfirmOrder,
      indicators,
      levelInfoDialog,
      SelectLevel,
      selectedLevel,
      selectedIndicator,
      indicatorInfoDialog,
      strategesInfoDialog,
      selectedStratege,
      serverUrl,
      strateges,
      instruments,
      positions,
      IsSetPosition,
      ConfirmStratege,
      strategeConfirmDialog,
      strategeMinPrice,
      strategeMaxPrice,
      strategePrice,
      SendStratege,
      CancelStratege,
      AddInstrument,
      //    handleClick,
      activeName,
      getStrategeTitle,
      tests,
    };
  },
});
</script>

<style lang="scss" scoped >
.testCard {
  width: 326px;
  height: 312px;
  border: 1px #d4d9dd solid;
  box-sizing: border-box;
  border-radius: 3px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  display: inline-flex;
  padding: 32px;
  margin-right: 12px;
  text-decoration: none;
}

.testCardText {
  font-family: Proxima Nova Bold;
  font-style: normal;
  /*  font-weight: bold;*/
  font-size: 18px;
  line-height: 19px;
  color: #222222;
  text-decoration: none;
}
.custom-tabs-label {
  text-align: right;
  font-family: Proxima Nova Condensed;
  font-size: 17px;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
}
.custom-tabs-label:hover {
  color: #00a76b;
}
.el-tabs__item:hover {
  color: #00a76b !important;
}
.el-tabs__active-bar {
  background-color: #00a76b !important;
}
.el-tabs__item.is-active {
  color: #00a76b !important;
}
.SAEcancelB {
  border: 1px solid #e82862 !important;
  border-radius: 0px !important;
  color: #e82862 !important;
}
.SAEconfirmB {
  border: 1px solid #e82862 !important;
  border-radius: 0px !important;
  background-color: #e82862 !important;
  color: white !important;
}
.myinputnumber .el-input__inner {
  height: 29px !important;
}
#SAE {
  width: 980px;
  .SAEblock {
    width: 380px;
    height: 481px;
    display: inline-block;
    margin-left: 30px;
    border: 1px #d4d9dd solid;
    box-sizing: border-box;
    border-radius: 3px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);

    position: relative;
    .SAEMultibuttonBlock {
      position: absolute;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      bottom: 32px;
      width: 100%;
      .SAEMultibutton {
        width: 45%;
        //display: inline-block;
        //margin: 0 2.4%;
      }
    }
    .SAEbutton {
      position: absolute;
      bottom: 32px;
      left: 64px;
    }
    .SAEprice {
      position: absolute;
      bottom: 96px;
      // left: 128px;
      width: 100%;
      text-align: center;
      span {
        font-size: 250%;
        color: green;
      }
    }
    .SAEimg {
      position: absolute;
      height: 105px;
      width: 99px;
      left: 7px;
      top: 32px;
      border-radius: 0px;
      background-repeat: no-repeat;
    }
    .SAEname {
      height: 48px;
      width: 154px;
      position: absolute;
      left: 122px;
      top: 38px;
      border-radius: 0px;
      //   font-family: Montserrat-Bold;
      font-size: 20px;
      font-style: normal;
      font-weight: 800;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      text-transform: uppercase;
      .SAEnamestatic {
        //   font-family: Montserrat;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .SAEheader {
      //   font-family: Montserrat-Bold;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: 0em;
      text-align: left;
      position: absolute;
      top: 128px;
      left: 32px;
      width: 320px;
      color: #222;
    }
    .SAEcontent {
      position: absolute;
      // overflow: hidden;
      top: 170px;
      left: 32px;
      width: 320px;
      height: 130px;
      //   font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      .viewfull {
        color: #e82862;
        font-size: 110%;
        text-decoration: underline;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
  .SAESblock {
    width: 380px;
    height: 331px;
    display: inline-block;
    margin-left: 30px;
    border: 1px #d4d9dd solid;
    box-sizing: border-box;
    border-radius: 3px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);

    position: relative;
    .SAESMultibuttonBlock {
      position: absolute;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      bottom: 32px;
      width: 100%;
      .SAESMultibutton {
        width: 45%;
        //display: inline-block;
        //margin: 0 2.4%;
      }
    }
    .SAESbutton {
      position: absolute;
      bottom: 32px;
      left: 64px;
    }
    .SAESprice {
      position: absolute;
      bottom: 96px;
      // left: 128px;
      width: 100%;
      text-align: center;
      span {
        font-size: 250%;
        color: green;
      }
    }
    .SAESimg {
      position: absolute;
      height: 105px;
      width: 99px;
      left: 7px;
      top: 32px;
      border-radius: 0px;
      background-repeat: no-repeat;
    }
    .SAESname {
      height: 48px;
      width: 254px;
      position: absolute;
      left: 122px;
      top: 38px;
      border-radius: 0px;
      //   font-family: Montserrat-Bold;
      font-size: 20px;
      font-style: normal;
      font-weight: 800;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      text-transform: uppercase;
      .SAESnamestatic {
        //   font-family: Montserrat;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: left;
      }
      .viewfull {
        color: #e82862;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        // font-size: 110%;
        text-decoration: underline;
        cursor: pointer;
        margin-left: 10px;
        text-transform: none;
      }
    }
    .SAESheader {
      //   font-family: Montserrat-Bold;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: 0em;
      text-align: left;
      position: absolute;
      top: 128px;
      left: 32px;
      width: 320px;
      color: #222;
    }
    .SAEScontent {
      position: absolute;
      // overflow: hidden;
      top: 170px;
      left: 32px;
      width: 320px;
      height: 130px;
      //   font-family: Montserrat;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      color: #222;
      .viewfull {
        color: #e82862;
        font-size: 110%;
        text-decoration: underline;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
}
.lk_content_title {
  font-family: Proxima Nova Extrabold;
  font-style: normal;
  /*font-weight: 800;*/
  font-size: 32px;
  line-height: 39px;
  /* identical to box height */

  color: #222222;
}
.el-dialog__title {
  font-family: Proxima Nova Extrabold;
  font-style: normal;
  /*font-weight: 800;*/
  font-size: 28px !important;
  line-height: 24px !important;
  /* identical to box height */
  color: #222222 !important;
}
.SAESblockHeader {
  border-bottom: #e82862 1px solid;
  margin: 20px 0 25px 0;
  div {
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: #222;
    margin-bottom: -10px;
    margin-left: 50px;
    background-color: white;
    width: fit-content;
    padding: 0px 5px 0px 5px;
  }
}
.SAESpopover {
  //  white-space:  break-spaces;
  word-break: normal !important;
}
#serviceForAE {
  .el-dialog__title {
    font-size: 18px !important;
  }
}
</style>
